import { getTextKey } from 'helpers/Notifications';

export const addToastrNotification = (notification, type = 'error', items = null, error) => {
    return {
        type: 'ADD_TOASTR',
        notification: notification,
        toastrType: type,
        items: items,
        error,
    };
};

export const removeToastrNotification = (notification) => {
    return {
        type: 'REMOVE_TOASTR',
        notification: notification,
    };
};

export const setFormProcessing = (form, processing) => {
    return {
        type: 'SET_FORM_PROCESSING',
        form: form,
        processing: processing,
    };
};

export const setProductAssemblyStatus = (productId, status) => {
    return {
        type: 'SET_PRODUCT_ASSEMBLY_STATUS',
        productId,
        status,
    };
};

export const saveStores = (stores) => {
    const formattedStores = [];
    for (const store in stores) {
        formattedStores.push({
            name: stores[store].name,
            value: store,
            isClose: stores[store].isClosed,
            closingTimes: stores[store].closingTimes,
        });
    }
    return {
        type: 'UPDATE_COLLECTION_STORES',
        stores: formattedStores,
    };
};

export const setCollectionSelectedStore = (storeId) => {
    return {
        type: 'SET_COLLECTION_SELECTED_STORE',
        storeId: storeId,
    };
};

export const setCollectError = (code) => {
    return {
        type: 'SET_COLLECTION_ERROR',
        code: code,
    };
};

export const saveZips = (zips) => {
    return {
        type: 'UPDATE_COLLECTION_ZIPS',
        zips: zips,
    };
};

export const setDeliverError = (code) => {
    return {
        type: 'SET_DELIVER_ERROR',
        code: code,
    };
};

export const setExpressDelivery = value => {
    return {
        type: 'SET_EXPRESS_DELIVERY',
        value,
    };
};

export const setItemsWithStockIssues = value => {
    return {
        type: 'SET_ITEMS_WITH_STOCK_ISSUES',
        value,
    };
};

export const setOrderReceipt = orderReceipt => ({
    type: 'SET_ORDER_RECEIPT',
    orderReceipt,
});

export const addProducts = (data, listType) => {
    return {
        type: 'ADD_PRODUCTS',
        products: data,
        listType: listType,
    };
};

export const setVATPrice = (value) => {
    return {
        type: 'SET_VAT_PRICE',
        value: value,
    };
};

export const setShoppingListView = (value) => {
    return {
        type: 'SET_SHOPPING_LIST_VIEW',
        value: value,
    };
};

export const updateShoppingLists = (lists, selectedList = '') => {
    return {
        type: 'UPDATE_SHOPPING_LISTS',
        lists: lists,
        selectedList: selectedList,
    };
};

export const addListError = (error = false) => {
    return {
        type: 'UPDATE_NEW_SHOPPING_LIST_ERROR',
        error: error,
    };
};

export const updateProductStock = (productId, stockAvailability, forecast, listType) => {
    return {
        type: 'UPDATE_STOCK_AVAILABILITY',
        productId: productId,
        stockAvailability: stockAvailability,
        stockForecast: forecast,
        listType: listType,
    };
};

export const updateProduct = (data, quantity, listType) => {
    return {
        type: 'UPDATE_PRODUCT',
        product: data,
        quantity: quantity,
        listType: listType,
    };
};

export const clearCartProducts = () => {
    return {
        type: 'CLEAR_CART_PRODUCTS',
    };
};

export const updateShoppingBag = (lists, bagId = '') => {
    return {
        type: 'UPDATE_SHOPPING_BAG',
        lists: lists,
        selectedList: bagId,
    };
};

export const setArtNbrError = (error) => {
    return {
        type: 'SET_ARTNBR_ERROR',
        error: getTextKey(error),
    };
};

export const updateShoppingListNoItems = (list, quantityDelta) => {
    return {
        type: 'UPDATE_LIST_NO_ITEMS',
        list: list,
        delta: quantityDelta,
    };
};

export const updateProductCollected = (collected, product, productId, listType) => {
    if (collected === true) {
        window.Checkout.analytics.logEvent('ecommerce', 'cross_off_checklist', window.Checkout.analytics.productId(product));
    }
    return {
        type: 'UPDATE_PRODUCT_COLLECTED',
        productId: productId,
        collected: collected,
        listType: listType,
    };
};

export const updatePartCollected = (partId, collected, productId, listType) => {
    // TODO should we log collected state here?
    return {
        type: 'UPDATE_PRODUCT_PART_COLLECTED',
        partId: partId,
        collected: collected,
        productId: productId,
        listType: listType,
    };
};

export const updateLoadingFlag = (isLoading) => {
    return {
        type: 'UPDATE_PRODUCTLIST_LOADING_FLAG',
        isLoading: isLoading,
    };
};

export const toggleChildrenDisplay = (article, value, listType) => {
    return {
        type: 'SHOW_CHILDREN_PRODUCTS',
        article: article,
        value: value,
        listType: listType,
    };
};

export const setLoading = (article, isLoading, listType) => {
    return {
        type: 'SET_LOADING',
        productId: article,
        isLoading: isLoading,
        listType: listType,
    };
};

export const removeProduct = (article, listType) => {
    return {
        type: 'REMOVE_PRODUCT',
        article: article,
        listType: listType,
    };
};

export const clearProducts = () => {
    return {
        type: 'CLEAR_PRODUCTS',
    };
};

export const setPaymentId = value => {
    return {
        type: 'SET_PAYMENT_ID',
        paymentId: value,
    };
};
export const setPaymentStatus = (status) => {
    return {
        type: 'SET_PAYMENT_STATUS',
        status,
    };
};

export const setDeliveryMethods = (deliveryMethods) => {
    return {
        type: 'SET_DELIVERY_METHODS',
        value: deliveryMethods,
    };
};

export const setDeliveryType = deliveryType => ({
    type: 'SET_DELIVERY_TYPE',
    deliveryType,
});
export const setDeliverySubType = deliverySubType => ({
    type: 'SET_DELIVERY_SUB_TYPE',
    deliverySubType,
});
export const _setDeliveryServicesId = (id) => {
    return {
        type: 'SET_DELIVERY_SERVICES_ID',
        id,
    };
};
export const setDeliveryArrangements = deliveryArrangements => ({
    type: 'SET_DELIVERY_ARRANGEMENTS',
    deliveryArrangements,
});
export const setOrderNumber = orderNumber => ({
    type: 'SET_ORDER_NUMBER',
    orderNumber,
});
export const setOrderPrices = (prices) => {
    return {
        type: 'SET_ORDER_PRICES',
        prices: prices,
    };
};

export const setCustomerType = (value) => {
    return {
        type: 'SET_CUSTOMER_TYPE',
        value: value,
    };
};

export const resetDirtyTimeSlotSelections = () => ({
    type: 'RESET_DIRTY_TIME_SLOT_SELECTIONS',
});

export const setSelectedTimeWindow = (deliveryArrangement, timeSlot) => ({
    type: 'SET_SELECTED_TIMESLOT',
    deliveryArrangement,
    timeSlot,
});

export const setQuestionnaireAnswer = answer => {
    return {
        type: 'SET_QUESTIONNAIRE_ANSWER',
        answer,
    };
};

export const setDirtyZipCodeFlag = value => {
    return {
        type: 'SET_DIRTY_ZIP_CODE',
        value,
    };
};

export const setPaymentRetry = (status) => {
    return {
        type: 'SET_PAYMENT_RETRY',
        status: status,
    };
};

export const setSelectedStore = (storeId) => {
    return {
        type: 'SET_SELECTED_STORE',
        storeId: storeId,
    };
};
export const setStores = (stores) => {
    return {
        type: 'SET_STORES',
        stores: stores,
    };
};

export const changeShoppingList = (value) => {
    return {
        type: 'UPDATE_SELECTED_LIST',
        selectedList: value,
    };
};

export const editListName = (list, value) => {
    return {
        type: 'EDIT_LIST_NAME',
        list: list,
        value: value,
    };
};

export const showRemoveConfirmation = (article, shouldShow, listType) => {
    return {
        type: 'SHOW_REMOVE_CONFIRMATION',
        productId: article,
        shouldShow: shouldShow,
        listType: listType,
    };
};

export const toggleDeleteListConfirmation = (list, value) => {
    return {
        type: 'TOGGLE_LIST_DELETE_CONFIRMATION',
        list: list,
        value: value,
    };
};

export const toggleEditList = (list, value) => {
    return {
        type: 'TOGGLE_LIST_EDIT',
        list: list,
        value: value,
    };
};

export const changeQuantity = (productId, newValue, listType) => {
    return {
        type: 'UPDATE_QUANTITY',
        productId: productId,
        quantity: newValue,
        listType: listType,
    };
};

export const setRemovingItems = value => {
    return {
        type: 'SET_REMOVING_ITEMS',
        value,
    };
};

export const updateProductPrices = (prices, article, listType) => {
    return {
        type: 'UPDATE_PRODUCT_PRICES',
        prices: prices,
        article: article,
        listType: listType,
    };
};

export const setListType = (value) => {
    return {
        type: 'SET_LIST_TYPE',
        value: value,
    };
};

export const updateAppLoadingFlag = (value) => {
    return {
        type: 'UPDATE_APP_LOADING_FLAG',
        value: value,
    };
};

export const setAuthenticationFlag = (value) => {
    return {
        type: 'SET_AUTHENTICATION_FLAG',
        value,
    };
};
